import { client } from "../../modules/ApolloClient";
import { RefreshToken } from "../gql/refreshToken/mutation";
import { log } from "../../utils/log";

const LIVIA_LS_KEY = "@Livia";

let refreshing = false;
let refreshPromise: Promise<any> | null = null;

export const getStoredTokens = () => {
    try {
      const raw = localStorage.getItem(LIVIA_LS_KEY);
      const parsed = raw ? JSON.parse(raw) : null;

      const hasToken = parsed?.token && parsed?.refreshToken;

      return hasToken ? parsed : null;
    } catch {
      log("Erro ao ler token do localStorage");
      return null;
    }
  };

export const saveTokens = (accessToken: string, refreshToken: string) => {
  const payload = {
    token: accessToken, 
    refreshToken,
    signed: Boolean(accessToken),
  };
  localStorage.setItem(LIVIA_LS_KEY, JSON.stringify(payload));
  log("Tokens salvos no localStorage");
};

export const isExpired = (token: string) => {
  try {
    const { exp } = JSON.parse(atob(token.split(".")[1]));
    const expired = Date.now() >= exp * 1000;
    log("Verificando expiração do token:", expired ? "expirado" : "válido");
    return expired;
  } catch {
    log("Token inválido (erro ao decodificar)");
    return true;
  }
};

export const refreshTokenIfNeeded = async (): Promise<boolean> => {
    const stored = getStoredTokens();

    if (!stored?.token) {
      log("Token não encontrado");
      return false;
    }

    if (!stored?.refreshToken || isExpired(stored?.refreshToken)) {
      log("RefreshToken não encontrado ou expirado");
      return false;
    }

    const token = stored.token;
    const refreshToken = stored.refreshToken;

    if (!token || isExpired(token)) {
      log("Token ausente ou expirado. Iniciando renovação...");

      if (refreshing && refreshPromise) return refreshPromise;

      refreshing = true;

      refreshPromise = client
        .mutate({
          mutation: RefreshToken,
          variables: { token: refreshToken },
          context: {
            headers: {
              Authorization: `Bearer ${token || "expired"}`,
            },
          },
        })
        .then(({ data }) => {
          const { access_token, refresh_token } = data.refreshToken;
          saveTokens(access_token, refresh_token);
          log("Token renovado com sucesso");
          return true;
        })
        .catch((err) => {
          log("Erro ao renovar token", err);
          return false;
        })
        .finally(() => {
          refreshing = false;
        });

      return refreshPromise;
    }

    log("Token ainda é válido. Nenhuma renovação necessária.");
    return false;
  };
